var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.5L0.00805567 4.41012C0.0503916 4.17688 0.25454 4 0.5 4H14.292L11.1464 0.853553L11.0886 0.784306C10.9536 0.589437 10.9729 0.320013 11.1464 0.146447C11.3417 -0.0488155 11.6583 -0.0488155 11.8536 0.146447L15.8536 4.14645L15.9114 4.21569C16.0464 4.41056 16.0271 4.67999 15.8536 4.85355L11.8536 8.85355L11.7843 8.91141C11.5894 9.0464 11.32 9.02712 11.1464 8.85355L11.0886 8.78431C10.9536 8.58944 10.9729 8.32001 11.1464 8.14645L14.292 5H0.5L0.410124 4.99194C0.176875 4.94961 0 4.74546 0 4.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.5L0.00805567 17.4101C0.0503916 17.1769 0.25454 17 0.5 17H14.292L11.1464 13.8536L11.0886 13.7843C10.9536 13.5894 10.9729 13.32 11.1464 13.1464C11.3417 12.9512 11.6583 12.9512 11.8536 13.1464L15.8536 17.1464L15.9114 17.2157C16.0464 17.4106 16.0271 17.68 15.8536 17.8536L11.8536 21.8536L11.7843 21.9114C11.5894 22.0464 11.32 22.0271 11.1464 21.8536L11.0886 21.7843C10.9536 21.5894 10.9729 21.32 11.1464 21.1464L14.292 18H0.5L0.410124 17.9919C0.176875 17.9496 0 17.7455 0 17.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.c3978641d69fc5a420653c2322958bd8.svg";
export { ForwardRef as ReactComponent };